
function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function formatCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  const clearValue = clearNumber(value);
  let nextValue  = `${clearValue.slice(0, 4)} ${clearValue.slice(4,8,)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      
  return nextValue.trim();
}

export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value);
  return clearValue.slice(0, 4);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  // Limit to 4 digits maximum (MM/YY)
  const limitedValue = clearValue.slice(0, 4);

  // Add slash after 2 digits (MM)
  if (limitedValue.length >= 2) {
    return `${limitedValue.slice(0, 2)}/${limitedValue.slice(2, 4)}`;
  }

  return limitedValue;
}

export function formatFormData(data) {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}
